import { c as _c } from "react/compiler-runtime";
import HeaderBlock from 'modules/profile/user-plan/components/price-plan-columns/components/header-block';
import { BillingPeriodEnum } from 'modules/profile/user-plan/enums/billing-period-enum';
import { UseUserPlanInterface, UserPlanInterface, tableFeatures } from 'modules/profile/user-plan/types/user-plan-interface';
import { getPricePlanFeatureTitle } from 'modules/profile/user-plan/utils/price-plan-utils';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export interface UserPlanColumnProps {
  pricePlan: UserPlanInterface;
  billingPeriod: BillingPeriodEnum;
  isOneClickUpgradeAvailable: boolean;
  paymentMethod: UseUserPlanInterface['customer']['paymentMethod'];
  isPlanUpgradeAvailable: boolean;
  showWithTax: boolean;
}
const UserPlanColumn = t0 => {
  const $ = _c(13);
  const {
    pricePlan,
    billingPeriod,
    isOneClickUpgradeAvailable,
    paymentMethod,
    isPlanUpgradeAvailable,
    showWithTax
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== billingPeriod || $[1] !== isOneClickUpgradeAvailable || $[2] !== isPlanUpgradeAvailable || $[3] !== paymentMethod || $[4] !== pricePlan || $[5] !== showWithTax) {
    t1 = <HeaderBlock pricePlan={pricePlan} billingPeriod={billingPeriod} isOneClickUpgradeAvailable={isOneClickUpgradeAvailable} paymentMethod={paymentMethod} isPlanUpgradeAvailable={isPlanUpgradeAvailable} showWithTax={showWithTax} />;
    $[0] = billingPeriod;
    $[1] = isOneClickUpgradeAvailable;
    $[2] = isPlanUpgradeAvailable;
    $[3] = paymentMethod;
    $[4] = pricePlan;
    $[5] = showWithTax;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== pricePlan || $[8] !== t) {
    t2 = tableFeatures.map((column, index) => <React.Fragment key={`column-${column.key}`}><div className="text-text-primary font-inter truncate text-center text-base">{getPricePlanFeatureTitle({
          pricePlan,
          key: column.key,
          t
        })}</div>{tableFeatures[index + 1] ? <hr className="border-fill-primary -mr-6 border-solid" /> : <div />}</React.Fragment>);
    $[7] = pricePlan;
    $[8] = t;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== t1 || $[11] !== t2) {
    t3 = <div className="slideScrollSnapAlignStart flex w-full min-w-full flex-col gap-2 border border-transparent lg:grid">{t1}{t2}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
export default UserPlanColumn;